// extracted by mini-css-extract-plugin
export default {"rangeSlider":"index_rangeSlider__dHUY5","inputSpacer":"index_inputSpacer__196i2"};